import React from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { InfoCard2 } from '../../../widgets/components/UI/InfoCard2'
import SyncedLogDataTable from './SyncedLogDataTable'
import { RecordsKeeperAISourcesAndSyncBreadCrumbs } from '../../core/_constants'

const SyncLog = () => {
    const { formatMessage } = useIntl()

    return (
        <>
            <div>
                <PageTitle
                    breadcrumbs={RecordsKeeperAISourcesAndSyncBreadCrumbs}
                    description={formatMessage({ id: ' Synced Log' })}
                >
                    {formatMessage({ id: 'RecordsKeeper AI' })}
                </PageTitle>
            </div>

            <div className='px-6'>
                <InfoCard2
                    title={'Track the syncing status of all your files here'}
                    desc={
                        `This section gives you a clear overview of your file syncing activity. Instantly check which files have synced successfully and identify any that failed. You can export the list of failed files to retry them easily. This tool helps ensure your documents are always up-to-date and correctly stored within RecordsKeeper.AI. You can also apply filters to narrow down your view based on storage type, file type, or a specific date range.`
                    }
                    slug={
                        'https://help.recordskeeper.ai/en/articles/11081210-file-sync-status-monitoring-and-management-in-recordskeeper-ai'
                    }
                />
                <SyncedLogDataTable />
            </div>
        </>
    )
}

export default SyncLog
